'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFooterProps = exports.getHeaderProps = exports.getSourceLabel = exports.getSubtitle = exports.getTitleLabel = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _header = require('../header');
var _ = require('../');
var _utils = require('./utils');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var isCustomInvalid = function isCustomInvalid(_ref) {
  var type = _ref.type;
  return function (value) {
    return R.isNil(value) || !(0, _utils.isChart)(type);
  };
};
var getDataflowName = function getDataflowName(props) {
  var dataflow = R.propOr({}, 'dataflow', props);
  var display = (0, _.parseDisplay)(props.display);
  return (0, _.dimensionValueDisplay)(display)(dataflow);
};
var getTitleLabel = exports.getTitleLabel = function getTitleLabel(props, state) {
  return R.when(isCustomInvalid({
    type: props.type
  }), R.always(getDataflowName(props)))(state.title);
};
var getSubtitle = exports.getSubtitle = function getSubtitle(props, state) {
  return R.ifElse(isCustomInvalid({
    type: props.type
  }), R.always((0, _header.getDefaultSubtitle)({
    customAttributes: props.customAttributes,
    dimensions: state.dimensions,
    display: props.display,
    units: state.units
  })), function (label) {
    var flags = (0, _header.getSubtitleFlags)({
      customAttributes: props.customAttributes,
      dimensions: state.dimensions,
      display: props.display,
      units: state.units
    });
    return [{
      label: label,
      flags: flags
    }];
  })(state.subtitle);
};
var getSourceLabel = exports.getSourceLabel = function getSourceLabel(props, state) {
  return R.when(isCustomInvalid({
    type: props.type
  }), R.always(getDataflowName(props)))(state.sourceLabel);
};
var getHeaderProps = exports.getHeaderProps = function getHeaderProps(props, state) {
  var title = {
    label: getTitleLabel(props, state),
    flags: (0, _header.getTitleFlags)({
      customAttributes: props.customAttributes,
      dataflowAttributes: state.dataflowAttributes,
      display: props.display
    })
  };
  var subtitle = getSubtitle(props, state);
  var uprs = (0, _header.getHeaderUnits)({
    display: props.display,
    units: R.assoc('values', R.pathOr([], ['units', 'headerUnits'], state))(R.pathOr({}, ['units', 'unitDimension'], props))
  });
  return {
    subtitle: subtitle,
    title: title,
    uprs: uprs
  };
};
var getFooterProps = exports.getFooterProps = function getFooterProps(props, state) {
  return {
    withCopyright: (0, _utils.isChart)(props.type) ? state.withCopyright : true,
    withLogo: (0, _utils.isChart)(props.type) ? state.withLogo : true,
    sourceLabel: getSourceLabel(props, state)
  };
};